<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <!-- <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un usuario</option>
        <option v-for="Usuario in Usuarios" :key="Usuario.IdUsuario" :value="Usuario.IdUsuario">{{Usuario.Nombre}}</option>
      </select> -->
      <Multiselect 
        v-model="idDelModelo"
        :id="idDelInput"
        :value="tipo.Id"
        :options="Usuarios"
        select-label="Seleccione un Usuario"           
        :show-labels="false"        
        @select="cambiarDatos"
        label="Nombre"
       >
        <span slot="noResult">{{placeholder}}</span>
      </Multiselect>
    </div>
  </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import axios from 'axios';
import api from '@/../static/js/api';
import comun from '@/../static/js/comun';
import Multiselect from 'vue-multiselect'

  export default {
    components:{Multiselect},
    data() {
      return {
        enumeraciones,
        Usuarios : [],
        idDelModelo: null,
        placeholder: "",
        comun
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object, 
      areaConsultaId: {
        type: Number,
        default: 0
      }
      
    },
    mounted() {      
      if (this.valorDefinido == undefined || this.valorDefinido == null)
        {this.idDelModelo = this.tipo.Id}
      else
        {this.idDelModelo = this.valorDefinido}

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.placeholder = this.tipo.Nombre + " un Usuario";
      //this.$store.dispatch("A_Cuentas_Usuarios_Establecer001Usuario", parametros); //Ojo
    },
    methods: {
      cargaListadoUsuariosArea(){
          var peticion = {
                "AreaId" : this.areaConsultaId,
                "conPermisos": false,
                "conPersona": true,
                "conAbogados": false,
                "conInactivos": false
              };
          var ListaFinal= [];
         
          axios.post(api.conexion + api.Cuentas.usuarios.C001Usuarios, peticion)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              $.each(respuesta.data.Usuarios, function(id, usuario)
              {
                ListaFinal.push({
                  IdUsuario: usuario.IdUsuario,
                  Nombre: (usuario.Nombre + (usuario.ApellidoPaterno!=null ? (" " + usuario.ApellidoPaterno): '') + (usuario.ApellidoMaterno!=null ? (" " + usuario.ApellidoMaterno): '')) + (usuario.Persona!=null ? (' - ' + usuario.Persona.Puesto) : '')
                })
              })
              this.Usuarios = ListaFinal; 
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          });

      },
      cambiarDatos(evento) {        
          this.idDelModelo = evento.IdUsuario; //target.value;
          const parametros = {
          llave: this.idDelInput,
          valor: evento.IdUsuario //target.value
        }
        //this.$store.dispatch("A_Cuentas_Usuarios_Establecer001Usuario", parametros);
        this.$emit("valorParaElPadre", evento);
      }
    },
    watch: {
      areaConsultaId (newArea, oldArea){
        if(newArea != oldArea)
          {
            this.cargaListadoUsuariosArea();
          }
      }
    },
    created(){
      this.cargaListadoUsuariosArea();
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option--highlight {
  background: #504f54;
}

.multiselect__option--selected.multiselect__option--highlight{
  background: #1b232c;
}
.multiselect__single {
  font-size:12px
}
.multiselect
{
  width:100%;
  min-height:18px;
  font-size:12px
}
</style>



// WEBPACK FOOTER //
// src/components/Cuentas/Usuarios/001UsuariosArea.vue